import { ImmutableObject } from '../../../utils/immutableObject';
import { EnumPricingItemType } from "./pricing-item-type";

export class PricingItem extends ImmutableObject {

    constructor(
        public readonly id?: string,
        public readonly family?: string,
        public readonly isSelected?: boolean,
        public readonly isValid?: boolean,
        public readonly userInputs?: Record<string, any>,
        public readonly prefilledInputs?: any,
        public readonly pricingItemType?: EnumPricingItemType,
        public readonly isCmc?: boolean,
        public readonly totalAppliedPrice?: string,
        public readonly matchingId?: string,
        public readonly displayOrder?: string,
        public readonly parentId?: string
    ) {
        super();
    }

    hasFranchiseConso(): boolean {
        return false;
    }
}
